import { getCopyYear } from 'utils';

const ViewComponent = ({}) => (
  <div className="z-50 flex w-full px-4 py-6 mx-auto text-center md:py-12 max-w-256 text-14-22 text-neutral-600 md:mt-0">
    <p>
      {`© ${getCopyYear()} Kanda is a trading style of Kanda Products & Services Ltd who is
      acting as a credit broker offering finance products available at
      competitive rates. Kanda Products & Services Ltd is authorized and
      regulated by the Financial Conduct Authority, registration number 920795
      and address is 17 High Street, Forward House, Henley-in-Arden,
      Warwickshire, England, B95 5AA. Credit is subject to status. Kanda may receive a commission for introducing you to a lender.`}
    </p>
  </div>
);

ViewComponent.displayName = 'Copyright-view';

export default ViewComponent;
